import { axios } from '@Root/API'

export const createFormEmail = payload => {
  return axios.post('cognito-form-emails', payload)
}
